<template>
  <div
    class="text-center sp-display-none"
    v-if="
      (transaction.transaction_type === 'omakase' ||
        transaction.transaction_type === 'partner') &&
      transaction.is_communication_refusable
    "
  >
    <button
      class="text-gray-92 w-80 h-10 mb-1 py-2 border border-gray-38 rounded-lg button-md bg-white hover:button"
      style="line-height: 24px"
      @click="showCommunicationRefuseDialog = true"
    >
      この案件を辞退する
    </button>
    <div class="body-sm text-gray-62">
      ※辞退した場合でも発生した紹介成立手数料は取り消せません。
    </div>
  </div>
  <div
    v-if="transaction.is_high_introduction_rate"
    class="mb-6 px-4 pt-3 pb-2 w-full bg-primary-container rounded sp-display-none"
  >
    <div>
      <span class="bg-primary-800 rounded-sm px-2 py-1 title-sm text-white">
        応募2件以下
      </span>
    </div>
    <div class="mt-1 body-md">
      応募期限が近づいていますが、現時点で応募数が2件以下の案件になります。
    </div>
  </div>
  <div class="text-center mb-6">
    <div v-if="isCancelableRefuse" class="sp-display-none">
      <div class="font-semibold">
        <div>この案件は辞退済みです。</div>
        <div>応募期限までは、辞退を取り消して応募できます。</div>
      </div>
      <div class="mt-4">
        <button
          class="button-md w-80 border py-2 px-8 rounded-lg font-bold bg-white hover:button"
          style="height: 40px"
          @click="postCancelRefused(transaction.transaction_id)"
        >
          辞退を取り消す
        </button>
      </div>
    </div>
    <div v-if="transaction.transactionStatus === 'communicating'">
      <div class="font-semibold">
        <div>この案件は、依頼企業とやりとり中です。</div>
        <div>
          契約が成立した、もしくは失注した場合は成約報告を行ってください。
        </div>
      </div>
      <div class="mt-4">
        <button
          class="button-md w-80 border py-2 px-8 rounded-lg font-bold bg-white hover:button"
          style="height: 40px"
          @click="showContractReportModal = true"
        >
          成約報告をする
        </button>
      </div>
    </div>
    <div v-if="transaction.transactionStatus === 'contract_ok'">
      <div class="font-semibold">
        <div>この案件は成約に至りました。おめでとうございます！</div>
        <div>依頼企業に請求書を発行する際に、請求額報告のページから</div>
        <div>請求額の報告を行ってください。</div>
      </div>
    </div>
    <div v-if="transaction.transactionStatus === 'contract_ng'">
      <div class="font-semibold">
        <div>この案件は、やりとりの結果</div>
        <div>成約に至らず終了しました。</div>
      </div>
    </div>
  </div>

  <div>
    <h2 class="text-2xl font-semibold text-gray-92 leading-8 mb-6">依頼概要</h2>

    <div
      v-if="conciergeComment"
      id="concierge-comment"
      class="mb-6 p-8 bg-white rounded-lg"
      style="max-width: 986px"
    >
      <div
        class="flex justify-between items-center sp-flex-direction-column sp-flex-align-start"
      >
        <h3 class="headline-sm text-gray-92">
          PRONIコンシェルジュからのひとことメモ
        </h3>
        <div class="body-sm text-gray-62">
          {{ conciergeComment.comment_edited_at
          }}<span v-if="conciergeComment.is_comment_updated">（更新済み）</span>
        </div>
      </div>
      <div class="body-sm text-gray-62">
        このメッセージは依頼企業には表示されません。
      </div>
      <div class="mt-4 body-md text-black" style="white-space: pre-wrap">
        {{ conciergeComment.comment }}
      </div>
    </div>

    <div
      id="selection-content"
      class="mb-6 p-8 bg-white rounded-lg"
      style="max-width: 986px"
    >
      <h3 class="text-xl font-semibold text-gray-92 mb-5 leading-8">
        募集内容
      </h3>
      <div class="text-sm">
        <div class="flex border-b border-gray-12 leading-6 py-3">
          <div class="flex sp-flex-direction-column">
            <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
              案件No
            </div>
            <div class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap">
              {{ transaction.transactionNo }}
            </div>
          </div>
        </div>
        <div>
          <div class="flex border-b border-gray-12 leading-6 py-3">
            <div class="flex sp-flex-direction-column">
              <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
                依頼企業名
              </div>
              <div
                class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap"
              >
                <span v-if="transaction.is_anonymous">非公開</span>
                <span v-else>{{ transaction.buyer_company_name ?? '' }}</span>
              </div>
            </div>
          </div>
        </div>
        <div v-if="buyerInformation.url || transaction.is_anonymous">
          <div class="flex border-b border-gray-12 leading-6 py-3">
            <div class="flex sp-flex-direction-column">
              <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
                依頼企業のWebサイトURL
              </div>
              <div
                class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap"
              >
                <span v-if="transaction.is_anonymous">非公開</span>
                <span v-else>
                  <a
                    class="underline"
                    :href="buyerInformation.url"
                    target="_blank"
                    rel="noopener"
                  >
                    {{ buyerInformation.url }}
                  </a>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="buyerInformation.company_address || transaction.is_anonymous"
        >
          <div class="flex border-b border-gray-12 leading-6 py-3">
            <div class="flex sp-flex-direction-column">
              <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
                依頼企業の所在地
              </div>
              <div
                class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap"
              >
                <span v-if="transaction.is_anonymous">非公開</span>
                <span v-else>{{ buyerInformation.company_address }}</span>
              </div>
            </div>
          </div>
        </div>
        <div class="flex border-b border-gray-12 leading-6 py-3">
          <div class="flex sp-flex-direction-column">
            <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
              カテゴリー
            </div>
            <div class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap">
              {{ transaction.service_category_name }}
            </div>
          </div>
        </div>
        <div v-for="item in items" :key="item.id">
          <div
            v-if="itemString(item)"
            class="flex border-b border-gray-12 leading-6 py-3"
          >
            <div class="flex sp-flex-direction-column">
              <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
                {{ item.name }}
              </div>
              <div
                v-if="item.identifier == 'reliable'"
                class="text-gray5 bg-slate-100 py-1 px-4 rounded-full flex"
              >
                <div class="flex items-center">
                  <template
                    v-if="itemOption(item).option_identifier == 'reliable1'"
                  >
                    <img src="@/assets/icons/Star1.svg" class="mr-1" />
                    <img src="@/assets/icons/Star.svg" class="mr-1" />
                    <img src="@/assets/icons/Star.svg" class="mr-1" />
                  </template>
                  <template
                    v-if="itemOption(item).option_identifier == 'reliable2'"
                  >
                    <img src="@/assets/icons/Star2.svg" class="mr-1" />
                    <img src="@/assets/icons/Star2.svg" class="mr-1" />
                    <img src="@/assets/icons/Star.svg" class="mr-1" />
                  </template>
                  <template
                    v-if="itemOption(item).option_identifier == 'reliable3'"
                  >
                    <img src="@/assets/icons/Star3.svg" class="mr-1" />
                    <img src="@/assets/icons/Star3.svg" class="mr-1" />
                    <img src="@/assets/icons/Star3.svg" class="mr-1" />
                  </template>
                </div>
                <div class="ml-2">{{ itemOption(item).name }}</div>
              </div>

              <div
                v-else
                class="text-gray-92 leading-5 py-1 flex-1 whitespace-pre-wrap"
                :class="
                  item.display_shape_type == 'label'
                    ? 'bg-slate-100 px-4 rounded-full'
                    : ''
                "
              >
                {{ itemString(item) }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="files && files.length > 0"
          class="flex sp-flex-direction-column border-b border-gray-12 leading-6 py-3"
        >
          <div class="w-56 pr-2 text-gray-62 font-semibold py-1 leading-6">
            添付ファイル
          </div>
          <div class="flex-1">
            <div v-for="(file, index) in files" :key="index" class="flex mb-2">
              <img
                style="width: 18px; height: 18px; margin-top: 2px"
                src="@/assets/icons/Clip.svg"
              />
              <a
                v-if="file.id && file.url"
                target="_blank"
                :href="file.url"
                class="ml-2 text-coral-main"
              >
                {{ file.name }}
              </a>
              <div v-else class="ml-2 text-coral-main">{{ file.name }}</div>
            </div>
          </div>
        </div>

        <div
          v-if="questions && questions.length > 0"
          class="flex sp-flex-direction-column border-b border-gray-12 py-3"
        >
          <div class="w-56 pr-2 text-gray-62 font-semibold py-1">
            質問リスト
          </div>
          <div class="flex-1">
            <div
              v-for="(question, index) in questions"
              :key="index"
              class="flex mb-2"
            >
              <div
                style="min-width: 20px; height: 20px"
                class="flex items-center justify-center rounded-full bg-slate-300"
              >
                <img src="@/assets/icons/AlphabetQ.svg" />
              </div>
              <div class="ml-2 whitespace-pre-wrap">{{ question.name }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      v-if="adminSupplements && adminSupplements.length > 0"
      id="admin-supplements"
      class="mb-6 p-8 bg-white rounded-lg"
      style="max-width: 986px"
    >
      <h3 class="text-xl pr-2 text-gray-92 font-semibold py-1 leading-6">
        PRONIメンバーズ事務局コメント
      </h3>
      <div
        v-for="(adminSupplement, index) in adminSupplements"
        :key="index"
        class="mr-2"
      >
        <div class="bg-slate-50 rounded mt-6 p-4 whitespace-pre-wrap">
          {{ adminSupplement.content }}
        </div>
        <div class="flex justify-end text-xs text-gray-500 mt-1">
          {{ adminSupplement.created_at }}
        </div>
      </div>
    </div>

    <transition name="right">
      <CompTxDecline
        v-if="showDeclineEstimate"
        class="fixed top-0 right-0 w-full z-50"
        :id="id"
        :selectId="selectId"
        :txType="txType"
        @close="showDeclineEstimate = false"
      ></CompTxDecline>
    </transition>
  </div>

  <ModalContractReport
    :isShow="showContractReportModal"
    :isLoading="isPostingContractReport"
    @submit="postContractReport"
    @cancel="showContractReportModal = false"
  />

  <ModalDialog
    :show-dialog="showCommunicationRefuseDialog"
    title="この案件を辞退しますか？"
    title-class="title-lg"
    close-text="キャンセル"
    close-text-border-class="border"
    close-text-color-class="text-gray-92"
    close-text-bg-class="bg-white"
    ok-text="辞退する"
    ok-text-color-class="text-white"
    ok-text-bg-class="bg-primary-light-high"
    @ok-action="postCommunicationRefuse()"
    @close-dialog="showCommunicationRefuseDialog = false"
  >
  </ModalDialog>
</template>

<script>
import { computed, inject, onMounted, reactive, toRefs, watch } from 'vue';
import { useRouter } from 'vue-router';
import { amountFormatter } from '@/utils/filters.js';
import axios from '@/utils/axiosAuth.js';
import CompTxDecline from '@/views/tx/vue/parts/CompTxDecline.vue';
import ModalContractReport from '@/components/ModalContractReport.vue';
import ModalDialog from '@/components/modalDialog.vue';

export default {
  props: {
    id: {
      type: [String, Number],
    },
    selectId: {
      type: [String, Number],
    },
    isCancelableRefuse: {
      type: [Boolean],
    },
  },
  components: {
    CompTxDecline,
    ModalContractReport,
    ModalDialog,
  },
  setup(props) {
    const globalMethods = inject('globalMethods');
    const router = useRouter();
    const state = reactive({
      transaction: {},
      items: {},
      files: [],
      questions: [],
      adminSupplements: [],
      conciergeComment: {},
      showDeclineEstimate: false,
      showContractReportModal: false,
      showCommunicationRefuseDialog: false,
      isPostingContractReport: false,
      enabledServiceContract: false,
      interactionAgreeCharge: 0,
      buyerInformation: {},
    });
    const route = computed(() => {
      return router.currentRoute.value;
    });
    const txType = computed(() => {
      return props.id ? 'tx' : 'tx-select';
    });
    const itemString = (data) => {
      let str = '';
      if (
        data.input_type === 'text' ||
        data.input_type === 'textarea' ||
        data.input_type === 'date' ||
        data.identifier === 'star'
      ) {
        str =
          data.display_format_type === 'number'
            ? amountFormatter(data.values[0])
            : data.values[0];
      } else if (data.input_type === 'checkbox') {
        const selected = data.options.filter(
          (option) =>
            data.values.findIndex((id) => {
              return id == option.id;
            }) >= 0
        );
        str = selected
          .map((e) => {
            return data.display_format_type === 'number'
              ? amountFormatter(e.name)
              : e.name;
          })
          .join(' / ');
      } else if (data.input_type === 'select' || data.input_type === 'radio') {
        const selected = data.options.find(
          (option) => option.id == data.values[0]
        );
        if (selected) {
          str =
            data.display_format_type === 'number'
              ? amountFormatter(selected.name)
              : selected.name;
        }
      }
      return str;
    };
    const itemOption = (data) => {
      if (data.input_type === 'select' || data.input_type === 'radio') {
        return data.options.find((option) => option.id == data.values[0]);
      }
      return {};
    };

    const hideCompleteMsg = () => {
      state.showCompleteMsg = false;
    };

    const getTransaction = async (id = null, targetTxType = txType.value) => {
      let path =
        targetTxType == 'tx'
          ? `/transactions/${id || props.id}/summary`
          : `/transaction-selects/${id || props.selectId}/summary`;
      const response = await axios.get(path).catch((e) => {
        // TODO: エラーメッセージ確認
        globalMethods.updateModal(
          true,
          'エラーが発生しました。',
          e.systemMessage || '',
          e.callback
        );
        globalMethods.sendLog(e);
      });

      if (response && response.data && response.data.data) {
        state.transaction = response.data.data.transaction;
        state.items = response.data.data.items;
        state.files = response.data.data.files;
        state.questions = response.data.data.questions;
        state.adminSupplements = response.data.data.admin_supplements;
        state.conciergeComment = response.data.data.concierge_comment;
        state.enabledServiceContract =
          response.data.data.is_service_contract_enabled;
        state.interactionAgreeCharge = amountFormatter(
          response.data.data.interaction_agree_charge
        );
        state.buyerInformation = { ...response.data.data.buyer_information };
      }
    };

    const postContractReport = async (contract) => {
      state.isPostingContractReport = true;

      let orderDetail = null;
      let scheduledInvoiceReportAmount = null;
      let scheduledInvoiceDate = null;

      // 「成約した」の場合のみ、データを送信
      if (contract.status === 'success') {
        orderDetail = contract.order_detail;
        scheduledInvoiceReportAmount = contract.scheduled_invoice_report_amount;
        scheduledInvoiceDate = contract.scheduled_invoice_date;
      }

      const postData = {
        step: 'contract',
        status:
          contract.status === 'success_undecided' ? 'success' : contract.status,
        order_detail: orderDetail,
        scheduled_invoice_report_amount: scheduledInvoiceReportAmount,
        scheduled_invoice_date: scheduledInvoiceDate,
      };

      await axios
        .post(
          `transactions/${state.transaction.transaction_id}/progresses/register`,
          postData
        )
        .then(() => {
          getTransaction();

          state.showContractReportModal = false;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        })
        .finally(() => {
          state.isPostingContractReport = false;
        });
    };

    const postCommunicationRefuse = async () => {
      await axios
        .post(
          `transactions/${state.transaction.transaction_id}/communication-refuse`
        )
        .then(() => {
          location.href = `${location.protocol}//${location.hostname}${route.value.fullPath}`;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'リクエストが完了しませんでした。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        })
        .finally(() => {
          state.showCommunicationRefuseDialog = false;
        });
    };

    const postCancelRefused = async (transactionId) => {
      await axios
        .post(
          `${process.env.VUE_APP_NEW_API_BASE_URL}/v2/selections/${transactionId}/cancel-refuse`
        )
        .then(() => {
          window.location = `/tx-select/${transactionId}/summary`;
        })
        .catch((e) => {
          globalMethods.updateModal(
            true,
            'エラーが発生しました。',
            e.systemMessage || '',
            e.callback
          );
          globalMethods.sendLog(e);
        });
    };

    onMounted(() => {
      getTransaction();
    });

    const isRouteParamChanged = (currentRouteParams, prevRouteParams) => {
      if (currentRouteParams.id && prevRouteParams.id) {
        return !(currentRouteParams.id === prevRouteParams.id);
      } else if (currentRouteParams.selectId && prevRouteParams.selectId) {
        return !(currentRouteParams.selectId === prevRouteParams.selectId);
      }
      return true;
    };
    watch(route, (currentRoute, prevRoute) => {
      // やることリストで遷移時のデータ更新
      if (
        ['TxSummary', 'TxSummaryMessage', 'TxSelectSummary'].includes(
          currentRoute.name
        ) &&
        isRouteParamChanged(currentRoute.params, prevRoute.params)
      ) {
        const id = currentRoute.params.id || currentRoute.params.selectId;
        const nextTxType = currentRoute.params.id ? 'tx' : 'tx-select';
        getTransaction(id, nextTxType);
      }
    });
    const newNextDomain = process.env.VUE_APP_NEW_NEXT_DOMAIN;
    return {
      ...toRefs(state),
      hideCompleteMsg,
      itemString,
      itemOption,
      txType,
      postContractReport,
      postCommunicationRefuse,
      postCancelRefused,
      newNextDomain,
    };
  },
};
</script>

<style lang="scss" scoped>
.right-enter-from,
.right-leave-to {
  transform: translateX(100vw);
}
.right-enter-active,
.right-leave-active {
  transition: transform 0.5s cubic-bezier(0, 0, 0.2, 1) 0ms;
}

@media (max-width: 640px) {
  .sp-flex-direction-column {
    flex-direction: column;
  }
  .sp-flex-align-start {
    align-items: start;
  }
  .sp-display-none {
    display: none;
  }
}
</style>
